import { jsx as _jsx } from "react/jsx-runtime";
import '@ant-design/v5-patch-for-react-19';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { AppProviders } from '@/app/providers/AppProviders';
import '@/styles/fonts.css';
import '@/styles/global.css';
import 'antd/dist/reset.css';
/** 应用外壳对应的 DOM 挂载节点。 */
const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Application root element was not found.');
}
createRoot(rootElement).render(_jsx(StrictMode, { children: _jsx(AppProviders, { children: _jsx(App, {}) }) }));
